// Route: /materials — LEGACY redirect → /library.
//
// «Материалы» + «Коллекции» слились в «Библиотеку» (обучающая система,
// docs/plans/LEARNING-SYSTEM-UI.md §2): один экран с фильтрами
// «Все / Не в курсе / Без папки», рельсом папок и мульти-выбором.
//
// ВАЖНО: редиректится ТОЛЬКО список. Страница источника
// `/materials/$materialId` (workspace материала) остаётся каноничной и здесь
// не участвует — её ломать нельзя.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

// Валидируем легаси-ключи, чтобы битый URL не падал ДО редиректа.
//
// ПОЧЕМУ SEARCH ПЕРЕКЛАДЫВАЕТСЯ ПОШТУЧНО, А НЕ `search as never` (2026-08-14).
// Прежний каст опирался на «zod отбросит незнакомые ключи сам» — и это верно
// ровно до момента, когда ключ не незнакомый, а ПЕРЕИМЕНОВАННЫЙ. Здесь именно
// такой случай: `setId` в Библиотеке называется `folder`, и ссылка вида
// `/materials?setId=<id>` (материалы одной папки) молча приземляла
// пользователя во всю Библиотеку — фильтр по папке терялся без следа.
//
// Остальные легаси-ключи целевая схема не знает и знать не должна
// (`status`, `preset`, `sortBy`), их роняем осознанно. `demo` у Библиотеки
// уже, чем здесь: значения `processing` / `offline` там не пройдут zod, так
// что переносим только пересекающиеся.
const searchSchema = z.object({
	type: z.string().optional(),
	status: z.string().optional(),
	setId: z.string().optional(),
	preset: z.enum(["all", "recent", "favorite"]).optional(),
	sortBy: z.enum(["updatedAt", "createdAt", "title"]).optional(),
	view: z.enum(["grid", "list"]).optional(),
	q: z.string().optional(),
	demo: z.enum(["default", "loading", "empty", "error", "processing", "offline"]).optional(),
});

export const Route = createFileRoute("/materials/")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		const demo =
			search.demo === "processing" || search.demo === "offline" ? undefined : search.demo;
		throw redirect({
			to: "/library",
			search: {
				...(search.q ? { q: search.q } : {}),
				...(search.type ? { type: search.type } : {}),
				...(search.view ? { view: search.view } : {}),
				// Переименование ключа, а не потеря: см. шапку файла.
				...(search.setId ? { folder: search.setId } : {}),
				...(demo ? { demo } : {}),
			},
			replace: true,
		});
	},
});
